import { Fragment, useEffect, useRef } from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import clock from '~/assets/icons/clock.svg';
import question from '~/assets/icons/question.svg';
import { ImgIcon } from '~/components/ui/ImgIcon';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import { formatTime } from '~/shared';
import {
	setQuestTabActiveMenuItem,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import { ButtonMenu } from '../ButtonMenu';
// import { QuestDailyTasks } from '../QuestDailyTasks';
import { QuestPromocodes } from '../QuestPromocodes';
import { Task } from '../Task';
import { TaskTimer } from '../TaskTimer';
import { QuestMenu, questMenuIcons, questMenuNames } from './QuestTab.model';
import {
	StyledContainer,
	StyledDailyTasksCompletedContainer,
	StyledDailyTasksTimerContainer,
	StyledEmptyTasksContainer,
	StyledTasksCompletedContainer,
	StyledTasksContainer,
	StyledTimer,
	StyledTopContainer,
	StyledTopRightContainer,
	StyledUpdateTasksContainer,
} from './QuestTab.styled';

const QuestTab = () => {
	const dispatch = useLayoutDispatch();
	const activeMenuItem = useLayoutSelector(
		(state) => state.mainMenu.questTabActiveMenuItem,
	);
	const taskList = useObservable(rage.dailyTasks.getTasks());
	const taskExpire = useObservable(rage.dailyTasks.getTasksExpireAt());
	const dailyProgress = useObservable(rage.dailyTasks.getDailyTasksProgress());
	const timerTextRef = useRef<HTMLDivElement | null>(null);
	const dailyTasksTimerTextRef = useRef<HTMLDivElement | null>(null);

	useEffect(() => {
		const targetTime = new Date(taskExpire);

		const updateTimeDifference = () => {
			if (!timerTextRef.current) return;
			const diff = targetTime.getTime() - Date.now();
			timerTextRef.current.textContent = formatTime(
				Math.max(0, diff),
				'{hh}:{mm}:{ss}',
			);
			if (!dailyTasksTimerTextRef.current) return;
			dailyTasksTimerTextRef.current.textContent = formatTime(
				Math.max(0, diff),
				'{hh}:{mm}:{ss}',
			);
		};

		updateTimeDifference();
		const intervalId = setInterval(updateTimeDifference, 1000);

		return () => clearInterval(intervalId);
	}, [taskExpire]);

	return (
		<StyledContainer>
			<StyledTopContainer>
				<ButtonMenu
					buttons={Object.values(QuestMenu).map((item) => ({
						label: questMenuNames[item],
						icon: questMenuIcons[item],
					}))}
					activeIndex={Object.values(QuestMenu).indexOf(activeMenuItem)}
					setActiveIndex={(index) =>
						dispatch(setQuestTabActiveMenuItem(Object.values(QuestMenu)[index]))
					}
				/>
				<StyledTopRightContainer>
					<StyledTasksCompletedContainer>
						<Text>Выполнено</Text>
						<Text>
							<span>{dailyProgress.completed}</span>
							{dailyProgress.limit != null
								? ` / ${dailyProgress.limit} задач`
								: ' задач'}
						</Text>
					</StyledTasksCompletedContainer>
					<StyledUpdateTasksContainer>
						<Text style={{ opacity: 0.5, color: '#ffffff' }}>
							Задачи обновятся через
						</Text>
						<StyledTimer />
						<Text
							ref={timerTextRef}
							style={{
								color: '#FFB500',
								marginTop: 1,
								minWidth: 69,
								fontWeight: 500,
							}}
						>
							00:00:00
						</Text>
					</StyledUpdateTasksContainer>
				</StyledTopRightContainer>
			</StyledTopContainer>
			<SwitchTransition>
				<CSSTransition
					timeout={300}
					classNames={'tab'}
					key={activeMenuItem}
					addEndListener={(node, done) =>
						node.addEventListener('transitionend', done, false)
					}
				>
					{activeMenuItem === QuestMenu.Quests ? (
						<Fragment>
							{taskList.length === 0 ? (
								<StyledEmptyTasksContainer>
									<Text>
										К сожалению,
										<br />
										доступных задач нет
									</Text>
								</StyledEmptyTasksContainer>
							) : dailyProgress.limit === dailyProgress.completed ? (
								<StyledDailyTasksCompletedContainer>
									<ImgIcon
										icon={question}
										width={20}
										height={20}
										color="rgba(255, 255, 255, 0.25)"
									/>
									<Text>
										Вы выполнили все доступные ежедневные задачи.
										<br />
										Задачи обновятся через:
									</Text>
									<StyledDailyTasksTimerContainer>
										<ImgIcon
											icon={clock}
											width={16}
											height={16}
											color="#FFB500"
										/>
										<Text ref={dailyTasksTimerTextRef}>00:00:00</Text>
									</StyledDailyTasksTimerContainer>
								</StyledDailyTasksCompletedContainer>
							) : (
								<StyledTasksContainer tabIndex={-1}>
									{taskList.map((item, index) => {
										if (item.currentCount === item.targetCount)
											return <TaskTimer key={index} taskExpire={taskExpire} />;

										return (
											<Task
												id={item.id}
												name={item.name}
												text={item.description}
												exp={item.rewardExp || 0}
												amount={item.rewardMoney || 0}
												progress={(item.currentCount / item.targetCount) * 100}
												key={index}
												type="daily"
											/>
										);
									})}
								</StyledTasksContainer>
							)}
						</Fragment>
					) : (
						// ) : activeMenuItem === QuestMenu.Daily ? (
						// 	<QuestDailyTasks />
						<QuestPromocodes />
					)}
				</CSSTransition>
			</SwitchTransition>
		</StyledContainer>
	);
};

export { QuestTab };
